<div class="card text-center bg-white h-100 animate__animated animate__fadeIn">
    <div class="card-body">
        <h4 class="card-title">{{'add_other_feedback.kudos.desc_1' | translate}}</h4>
        <h5 class="card-text">{{'add_other_feedback.kudos.desc_2' | translate}}</h5>
        <div class="my-4">
            <img src="/assets/images/add_comment/kudos.svg">
        </div>
    </div>
    <div class="card-footer bg-white border-0">
        <button class="btn btn-primary py-2" data-cy="request-kudos-btn" (click)="createKudos()">{{'add_other_feedback.kudos.send' | translate}}</button>
    </div>
</div>   